import React from 'react'
import PropTypes from 'prop-types'
import { useFlag } from '@unleash/proxy-client-react'
import SwitchMaterial from 'app/components/SwitchMaterial'
import { makeStyles } from '@material-ui/core/styles'
import * as R from 'ramda'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'

const NOTIFICATION_EVENT_TYPE = 2
const useStyles = makeStyles((theme) => ({
  switchMaterial: {
    marginLeft: '-10px !important',
  },
}))
const checkExpiredDate = (date) => {
  return moment(date).isBefore(moment())
}
const DisplayHistoryToggle = ({ notification, updateDisplayHistory }) => {
  const classes = useStyles()

  const isExpired = R.compose(
    R.ifElse(R.isNil, R.always(false), checkExpiredDate),
    R.prop('expirationDate'),
  )(notification)

  const isEventEnded = R.propEq('type', NOTIFICATION_EVENT_TYPE, notification)
    ? checkExpiredDate(R.prop('endTime', notification))
    : false

  const isCalceled = R.compose(
    R.not,
    R.isNil,
    R.prop('canceledDate'),
  )(notification)

  const isUnsent = R.compose(R.not, R.isNil, R.prop('unsentDate'))(notification)

  const isScheduleCancel = R.compose(
    R.not,
    R.isNil,
    R.prop('scheduleCancelDate'),
  )(notification)

  const isSharingEnabled = R.prop('isSharingEnabled', notification)

  if (
    isExpired ||
    isEventEnded ||
    isCalceled ||
    isUnsent ||
    isScheduleCancel ||
    !isSharingEnabled
  ) {
    return null
  }

  return (
    <div className="flex">
      <SwitchMaterial
        className={classes.switchMaterial}
        value={R.prop('displayHistory', notification)}
        onChange={(value) => {
          updateDisplayHistory({
            notificationId: R.prop('id', notification),
            displayHistory: value,
          })
        }}
      />
      <span className="self-center text-xs">
        <FormattedMessage id="notification.timeline.toggle.label" />
      </span>
    </div>
  )
}

DisplayHistoryToggle.propTypes = {
  notification: PropTypes.object,
  updateDisplayHistory: PropTypes.func,
}

export default DisplayHistoryToggle
